<template>
  <div id="app" :page="$route.name" :page-loading="pageLoading" :menu-opened="menuOpened" :edge="isEdge" :dialog="dialog">
    <div class="page-loader">
      <img ref="pageLoader">
      <div class="loader-text">loading</div>
    </div>
    <header>
      <div class="wrapper">
        <router-link to="/">
          <img class="logo" :src="require(`@/assets/cast_logo.svg`)" alt="CAST Project">
        </router-link>
        <nav ref="nav">
          <router-link to="/" @click.native="menuOpened = false"><i class="fas fa-home"></i></router-link>
          <router-link to="/about" @click.native="menuOpened = false">About</router-link>
          <router-link to="/smart-map" @click.native="menuOpened = false">SmartMap</router-link>
          <router-link to="/companies" @click.native="menuOpened = false">Companies</router-link>
          <router-link to="/resources" @click.native="menuOpened = false">Resources</router-link>
          <router-link to="/news" @click.native="menuOpened = false">News</router-link>
          <router-link to="/events" @click.native="menuOpened = false">Events</router-link>
          <router-link to="/partners" @click.native="menuOpened = false">Partners</router-link>
          <router-link to="/contact" @click.native="menuOpened = false">Contact</router-link>
          <router-link to="/register" class="btn btn-ic" @click.native="menuOpened = false">
            <span>Get support</span>
            <i class="btn-icon fas fa-long-arrow-alt-right"></i>
            <i class="line1"></i>
            <i class="line2"></i>
          </router-link>
          <i ref="navBar" class="bar"></i>
        </nav>
        <button class="menu-btn" @click="menuOpened = !menuOpened">
          <i class="ic ic-menu"></i>
          <span>Menu</span>
        </button>
        <button class="menu-btn close-btn" @click="menuOpened = !menuOpened">
          <i class="ic ic-close"></i>
          <span>Close</span>
        </button>
      </div>
    </header>
    <main>
      <!-- <div class="no-mobile" style="padding: 240px 24px 30px; text-align: center; font-size: 24px;" v-if="isMobile">
        <p>This website is not available on mobile devices yet.<br><br>Visit this page on desktop to enjoy the full experience.</p>
      </div> -->
      <router-view />
    </main>
    <footer v-if="$route.name !== 'hackathon'">
      <div class="footer-background" v-if="!isMobile">
        <img v-if="$route.name === 'resources'" src="@/assets/cast_resources_footer.png">
        <svg v-else-if="$route.name === 'events' || $route.name === 'event'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="674" viewBox="0 0 1900 674"><defs><clipPath id="ef-a"><rect width="1900" height="674" transform="translate(0 3891)" fill="none"/></clipPath><linearGradient id="ef-b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#ffd400"/><stop offset="0.994" stop-color="#8abb2a"/></linearGradient><filter id="ef-d" x="-248.984" y="-63.022" width="2340.492" height="934.022" filterUnits="userSpaceOnUse"><feOffset dy="-19" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="e"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="e"/><feComposite in="SourceGraphic"/></filter><filter id="ef-f" x="576.5" y="329.5" width="92" height="92" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="g"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="g"/><feComposite in="SourceGraphic"/></filter><filter id="ef-i" x="655.354" y="332.854" width="191.848" height="162.557" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="j"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="j"/><feComposite in="SourceGraphic"/></filter><filter id="ef-l" x="726.999" y="287.544" width="83.944" height="83.944" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="m"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="m"/><feComposite in="SourceGraphic"/></filter><filter id="ef-o" x="1319.999" y="341.544" width="83.944" height="83.944" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="p"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="p"/><feComposite in="SourceGraphic"/></filter><filter id="ef-r" x="1473.38" y="364.213" width="91.293" height="91.293" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="s"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="s"/><feComposite in="SourceGraphic"/></filter><filter id="ef-u" x="1593.38" y="274.906" width="80.27" height="80.27" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="v"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="v"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(0 -3891)" clip-path="url(#ef-a)"><g transform="translate(0 -2283)"><path d="M-12231.953,6315c105.9-166.074,456.437-7.638,597.849,224.417,102.52,168.233,62.651,258.834,38.323,316.146-30.889,72.767-391.171,167.961-562.13,0C-12308.576,6707.54-12317.254,6448.776-12231.953,6315Z" transform="translate(12168)" fill="url(#ef-b)"/><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#ef-d)"><path d="M-12157.641,6875.047l-47.344-153.016s347.453-229.852,628.547-273.32,38.6,170.072,313.2,117.539,507.674,110.557,717.242-77.664c155.079-139.282,127.711-185.34,208.43-210.656s167.781,79.289,167.781,79.289l17.3,562.781Z" transform="translate(12100 -6174)" fill="url(#ef-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#ef-f)"><circle cx="17.5" cy="17.5" r="17.5" transform="translate(605 346)" fill="#fff"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#ef-i)"><path d="M-10803.09,6450.255c13.739-19.358,66.923-54.794,93.38-54.794s26.191,35.436,12.451,54.794-40.951,22.64-67.408,22.64S-10816.829,6469.613-10803.09,6450.255Z" transform="matrix(-0.97, -0.26, 0.25, -0.97, -11295.29, 3835.42)" fill="url(#ef-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#ef-l)"><circle cx="11" cy="11" r="11" transform="matrix(-0.97, -0.26, 0.26, -0.97, 776.75, 330.99)" fill="url(#ef-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#ef-o)"><circle cx="11" cy="11" r="11" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1369.75, 384.99)" fill="url(#ef-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#ef-r)"><circle cx="14" cy="14" r="14" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1528.93, 415.01)" fill="url(#ef-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#ef-u)"><circle cx="9.5" cy="9.5" r="9.5" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1640.23, 314.68)" fill="url(#ef-b)"/></g></g></g></svg>
        <svg v-else-if="$route.name === 'news' || $route.name === 'post'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="734" viewBox="0 0 1900 734"><defs><clipPath id="nf-a"><rect width="1900" height="734" transform="translate(0 3366)" fill="none"/></clipPath><linearGradient id="nf-b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#e77323"/><stop offset="0.08" stop-color="#f77e0b"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/></linearGradient><linearGradient id="nf-c" x1="0.47" y1="-0.026" x2="0.524" y2="1.27" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#e77323"/><stop offset="0.08" stop-color="#f77e0b"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/><stop offset="1" stop-color="#880f50"/></linearGradient><filter id="nf-d" x="-248.984" y="-53.022" width="2340.492" height="934.022" filterUnits="userSpaceOnUse"><feOffset dy="-19" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="e"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="e"/><feComposite in="SourceGraphic"/></filter><filter id="nf-f" x="576.5" y="339.5" width="92" height="92" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="g"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="g"/><feComposite in="SourceGraphic"/></filter><linearGradient id="nf-h" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#ba146d"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/><stop offset="1" stop-color="#880f50"/></linearGradient><filter id="nf-i" x="655.354" y="342.854" width="191.848" height="162.557" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="j"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="j"/><feComposite in="SourceGraphic"/></filter><filter id="nf-l" x="726.999" y="297.544" width="83.944" height="83.944" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="m"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="m"/><feComposite in="SourceGraphic"/></filter><filter id="nf-o" x="1319.999" y="351.544" width="83.944" height="83.944" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="p"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="p"/><feComposite in="SourceGraphic"/></filter><filter id="nf-r" x="1473.38" y="374.213" width="91.293" height="91.293" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="s"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="s"/><feComposite in="SourceGraphic"/></filter><filter id="nf-u" x="1593.38" y="284.906" width="80.27" height="80.27" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="v"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="v"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(0 -3366)" clip-path="url(#nf-a)"><g transform="translate(0 -2798)"><path d="M-12231.953,6315c105.9-166.074,456.437-7.638,597.849,224.417,102.52,168.233,62.651,258.834,38.323,316.146-30.889,72.767-391.171,167.961-562.13,0C-12308.576,6707.54-12317.254,6448.776-12231.953,6315Z" transform="translate(12168)" fill="url(#nf-b)"/><g transform="matrix(1, 0, 0, 1, 0, 6164)" filter="url(#nf-d)"><path d="M-12156.445,6897.89l-48.539-175.859s347.453-229.852,628.547-273.32,38.6,170.072,313.2,117.539,507.674,110.557,717.242-77.664c155.079-139.282,127.711-185.34,208.43-210.656s167.781,79.289,167.781,79.289l17.3,562.781Z" transform="translate(12100 -6164)" fill="url(#nf-c)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6164)" filter="url(#nf-f)"><circle cx="17.5" cy="17.5" r="17.5" transform="translate(605 356)" fill="#fff"/></g><g transform="matrix(1, 0, 0, 1, 0, 6164)" filter="url(#nf-i)"><path d="M-10803.09,6450.255c13.739-19.358,66.923-54.794,93.38-54.794s26.191,35.436,12.451,54.794-40.951,22.64-67.408,22.64S-10816.829,6469.613-10803.09,6450.255Z" transform="matrix(-0.97, -0.26, 0.25, -0.97, -11295.29, 3845.42)" fill="url(#nf-h)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6164)" filter="url(#nf-l)"><circle cx="11" cy="11" r="11" transform="matrix(-0.97, -0.26, 0.26, -0.97, 776.75, 340.99)" fill="url(#nf-h)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6164)" filter="url(#nf-o)"><circle cx="11" cy="11" r="11" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1369.75, 394.99)" fill="url(#nf-h)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6164)" filter="url(#nf-r)"><circle cx="14" cy="14" r="14" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1528.93, 425.01)" fill="url(#nf-h)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6164)" filter="url(#nf-u)"><circle cx="9.5" cy="9.5" r="9.5" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1640.23, 324.68)" fill="url(#nf-h)"/></g></g></g></svg>
        <svg v-else-if="$route.name === 'partners'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="700" viewBox="0 0 1900 700"><defs><clipPath id="pf-a"><rect width="1900" height="700" transform="translate(0 2072)" fill="none"/></clipPath><linearGradient id="pf-b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#ba146d"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/><stop offset="1" stop-color="#880f50"/></linearGradient><filter id="pf-d" x="-248.984" y="-27.022" width="2340.492" height="934.022" filterUnits="userSpaceOnUse"><feOffset dy="-19" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="e"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="e"/><feComposite in="SourceGraphic"/></filter><filter id="pf-f" x="576.5" y="365.5" width="92" height="92" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="g"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="g"/><feComposite in="SourceGraphic"/></filter><filter id="pf-i" x="655.354" y="368.854" width="191.848" height="162.557" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="j"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="j"/><feComposite in="SourceGraphic"/></filter><filter id="pf-l" x="726.999" y="323.544" width="83.945" height="83.944" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="m"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="m"/><feComposite in="SourceGraphic"/></filter><filter id="pf-o" x="1319.999" y="377.544" width="83.945" height="83.944" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="p"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="p"/><feComposite in="SourceGraphic"/></filter><filter id="pf-r" x="1473.38" y="400.213" width="91.293" height="91.293" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="s"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="s"/><feComposite in="SourceGraphic"/></filter><filter id="pf-u" x="1593.38" y="310.906" width="80.27" height="80.27" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="v"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="v"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(0 -2072)" clip-path="url(#pf-a)"><g transform="translate(0 -4066)"><path d="M-12231.953,6315c105.9-166.074,456.437-7.638,597.849,224.417,102.52,168.233,62.651,258.834,38.323,316.146-30.889,72.767-391.171,167.961-562.13,0C-12308.576,6707.54-12317.254,6448.776-12231.953,6315Z" transform="translate(12168)" fill="url(#pf-b)"/><g transform="matrix(1, 0, 0, 1, 0, 6138)" filter="url(#pf-d)"><path d="M-12157.641,6875.047l-47.344-153.016s347.453-229.852,628.547-273.32,38.6,170.072,313.2,117.539,507.674,110.557,717.242-77.664c155.079-139.282,127.711-185.34,208.43-210.656s167.781,79.289,167.781,79.289l17.3,562.781Z" transform="translate(12100 -6138)" fill="url(#pf-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6138)" filter="url(#pf-f)"><circle cx="17.5" cy="17.5" r="17.5" transform="translate(605 382)" fill="#fff"/></g><g transform="matrix(1, 0, 0, 1, 0, 6138)" filter="url(#pf-i)"><path d="M-10803.09,6450.255c13.739-19.358,66.923-54.794,93.38-54.794s26.191,35.436,12.451,54.794-40.951,22.64-67.408,22.64S-10816.829,6469.613-10803.09,6450.255Z" transform="matrix(-0.97, -0.26, 0.25, -0.97, -11295.29, 3871.42)" fill="url(#pf-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6138)" filter="url(#pf-l)"><circle cx="11" cy="11" r="11" transform="matrix(-0.97, -0.26, 0.26, -0.97, 776.75, 366.99)" fill="url(#pf-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6138)" filter="url(#pf-o)"><circle cx="11" cy="11" r="11" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1369.75, 420.99)" fill="url(#pf-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6138)" filter="url(#pf-r)"><circle cx="14" cy="14" r="14" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1528.93, 451.01)" fill="url(#pf-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6138)" filter="url(#pf-u)"><circle cx="9.5" cy="9.5" r="9.5" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1640.23, 350.68)" fill="url(#pf-b)"/></g></g></g></svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="698" viewBox="0 0 1900 698"><defs><clipPath id="hf-a"><rect width="1900" height="698" transform="translate(0 6174)" fill="none"/></clipPath><linearGradient id="hf-b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient><filter id="hf-d" x="-248.984" y="-63.022" width="2340.492" height="934.022" filterUnits="userSpaceOnUse"><feOffset dy="-19" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="e"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="e"/><feComposite in="SourceGraphic"/></filter><filter id="hf-f" x="576.5" y="329.5" width="92" height="92" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="g"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="g"/><feComposite in="SourceGraphic"/></filter><filter id="hf-i" x="726.999" y="287.544" width="83.944" height="83.944" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="j"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="j"/><feComposite in="SourceGraphic"/></filter><filter id="hf-k" x="1319.999" y="341.544" width="83.944" height="83.944" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="l"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="l"/><feComposite in="SourceGraphic"/></filter><filter id="hf-m" x="1473.38" y="364.213" width="91.293" height="91.293" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="n"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="n"/><feComposite in="SourceGraphic"/></filter><filter id="hf-o" x="1593.38" y="274.906" width="80.271" height="80.27" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="p"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="p"/><feComposite in="SourceGraphic"/></filter><filter id="hf-r" x="655.354" y="332.854" width="191.848" height="162.557" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="s"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="s"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(0 -6174)"><g clip-path="url(#hf-a)"><path d="M-12231.953,6315c105.9-166.074,456.437-7.638,597.849,224.417,102.52,168.233,62.651,258.834,38.323,316.146-30.889,72.767-391.171,167.961-562.13,0C-12308.576,6707.54-12317.254,6448.776-12231.953,6315Z" transform="translate(12168)" fill="url(#hf-b)"/><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#hf-d)"><path d="M-12157.641,6875.047l-47.344-153.016s347.453-229.852,628.547-273.32,38.6,170.072,313.2,117.539,507.674,110.557,717.242-77.664c155.079-139.282,127.711-185.34,208.43-210.656s167.781,79.289,167.781,79.289l17.3,562.781Z" transform="translate(12100 -6174)" fill="url(#hf-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#hf-f)"><circle cx="17.5" cy="17.5" r="17.5" transform="translate(605 346)" fill="#fff"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#hf-i)"><circle cx="11" cy="11" r="11" transform="matrix(-0.97, -0.26, 0.26, -0.97, 776.75, 330.99)" fill="url(#hf-b)"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#hf-k)"><circle cx="11" cy="11" r="11" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1369.75, 384.99)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#hf-m)"><circle cx="14" cy="14" r="14" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1528.93, 415.01)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#hf-o)"><circle cx="9.5" cy="9.5" r="9.5" transform="matrix(-0.97, -0.26, 0.26, -0.97, 1640.23, 314.68)" fill="#00a1ed"/></g></g><g transform="matrix(1, 0, 0, 1, 0, 6174)" filter="url(#hf-r)"><path d="M-10803.09,6450.255c13.739-19.358,66.923-54.794,93.38-54.794s26.191,35.436,12.451,54.794-40.951,22.64-67.408,22.64S-10816.829,6469.613-10803.09,6450.255Z" transform="matrix(-0.97, -0.26, 0.25, -0.97, -11295.29, 3835.42)" fill="url(#hf-b)"/></g></g></svg>
      </div>
      <img class="footer-logo" src="@/assets/cast_logo-footer.svg" alt="CAST Project">
      <div class="footer-copyright">© <DateFormat format="%Y" :date="new Date()" /> CAST | <router-link to="/contact">Contact</router-link></div>
      <div class="wrapper socials">
        <a href="https://twitter.com/CastnetworkE" target="_blank">
          <i class="fab fa-twitter"></i>
        </a>
        <a href="https://www.linkedin.com/showcase/cast-network-eu/about/" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
        <div>Follow us</div>
      </div>
      <div class="footer-contact-mobile"><router-link to="/contact">Contact</router-link></div>
      <div class="footer-content">
        <div class="footer-made-by">Website made with ❤️ by <a href="https://blackpugstudio.com" alt="Black Pug Studio | Creative Website Agency | Galway, Ireland" target="_blank" rel="noopener">Black Pug Studio</a></div>
        <img src="@/assets/cast_ic_eu.png" alt="European Initiative" class="flag">
        <div class="disclaimer"><span>Co-funded by the COSME program of the European Commmission under GA n.806917</span><br><br>The content of this website represents the views of the author only and is his/her sole responsibility; it cannot be considered to reflect the views of the European Commission and/or the Executive Agency for Small and Medium-sized Enterprises (EASME) or any other body of European Union. The European Commission and the Agency do not accept any responsibility for the use that may be made of the information it contains.</div>
        <div class="links">
          <div>Use of this site:</div>
          <router-link to="/pages/terms-and-conditions" disabled>Terms & Conditions</router-link>
          <router-link to="/pages/cookie-policy" disabled>Cookie Policy</router-link>
        </div>
        <div class="links">
          <div>European inquiries:</div>
          <a href="mailto:info@castnetwork.eu">info@castnetwork.eu</a>
        </div>
      </div>
      <div class="copyright-mobile">© <DateFormat format="%Y" :date="new Date()" /> CAST</div>
    </footer>
    <div class="cookie-bar" :opened="cookieOpened">
      <span>We use <router-link to="/pages/cookie-policy" disabled>cookies!</router-link></span>
      <i class="ic ic-cookies"></i>
      <button class="btn btn-s" @click="acceptCookie">Accept</button>
    </div>
    <div class="overlay">
      <div class="dialog ie" v-if="dialog === 'ie'">
        <button class="ic ic-close-b" @click="dialog = null"></button>
        <h4>Note</h4>
        <div class="dialog-content">This website is not optimized for this browser, please use another browser to benefit from an optimal experience. Recommended browsers are Chrome, Firefox and Safari.</div>
      </div>
      <div class="dialog hackathon" v-else-if="dialog === 'hackathon' && hackathon">
        <button class="ic ic-close-b" @click="closeHackathon"></button>
        <h4>CAST Final Conference</h4>
        <div class="dialog-content">
          <h2>{{hackathon.title}}</h2>
          <div class="hackathon-dates">{{hackathon.dates}}</div>
          <div class="hackathon-location">{{hackathon.location}}</div>
        </div>
        <div class="dialog-footer">
          <router-link class="btn" to="/finalconference" @click.native="closeHackathon">Read more</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import DateFormat from './components/DateFormat'

export default {
  name: 'app',
  data() {
    return {
      cookieOpened: false,
      menuOpened: false,
      isEdge: document.documentMode || /Edge/.test(navigator.userAgent),
      dialog: null,
      hackathon: null,
    }
  },
  components: {
    DateFormat,
  },
  watch: {
    $route() {
      this.menuOpened = false
    },
    pageLoading(loading) {
      clearTimeout(this.loadingTO)
      if(!loading) this.loadingTO = setTimeout(() => this.$refs.pageLoader.src = null, 300)
      else this.$refs.pageLoader.src = require('@/assets/cast_ic_loading.gif')
    }
  },
  computed: {
    ...mapGetters({
      pageLoading: 'getPageLoading',
      isMobile: 'getMobile',
      db: 'getDb',
    })
  },
  methods: {
    acceptCookie() {
      const d = new Date()
      d.setTime(d.getTime() + (30*24*60*60*1000))
      var expires = "expires=" + d.toUTCString()
      document.cookie = "allow_cookies=1;" + expires + ";path=/"
      this.cookieOpened = false
    },
    getDate() {
      const d = new Date()
      return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
    },
    closeHackathon() {
      window.localStorage.setItem('finalconference', this.getDate())
      this.dialog = null
    }
  },
  mounted: function() {
    if(window.navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
      this.dialog = 'ie'
    }
    setTimeout(() => {
      const v = document.cookie.match('(^|;) ?allow_cookies=1(;|$)')
      this.cookieOpened = !v
    }, 3000)
    const hack = window.localStorage && window.localStorage.getItem('finalconference')
    if(!window.location.pathname.startsWith('/finalconference') && hack !== this.getDate()) {
      this.db().doc('settings/hackathon').get().then(hackathon => {
        this.hackathon = hackathon.data()
        this.dialog = 'hackathon'
      })
    }
    this.$nextTick(() => {
      const links = this.$el.querySelectorAll('nav a:not(.btn)')
      links.forEach(link => {
        link.addEventListener('mouseenter', () => {
          const nav = link.parentNode.getBoundingClientRect()
          const pos = link.getBoundingClientRect()
          this.$refs.navBar.style.width = `${pos.width}px`
          this.$refs.navBar.style.transform = `translateX(${pos.left - nav.left}px)`
        })
        this.$refs.nav.addEventListener('mouseleave', () => {
          const active = this.$el.querySelectorAll('nav a.router-link-active:not(.btn)')
          const selected = active[active.length - 1] || links[0]
          if(selected) {
            const nav = link.parentNode.getBoundingClientRect()
            const pos = selected.getBoundingClientRect()
            this.$refs.navBar.style.width = `${pos.width}px`
            this.$refs.navBar.style.transform = `translateX(${pos.left - nav.left}px)`
          }
        })
      })
      window.addEventListener('resize', () => this.$refs.nav.dispatchEvent(new Event('mouseleave')))
      this.$nextTick(() => this.$refs.nav.dispatchEvent(new Event('mouseleave')))
      if(this.pageLoading) this.$refs.pageLoader.src = require('@/assets/cast_ic_loading.gif')
    })
  }
}
</script>


<style>
@font-face {
    font-family: 'Butler';
    src: url('/fonts/Butler-UltraLight.woff2') format('woff2'),
        url('/fonts/Butler-UltraLight.woff') format('woff');
    font-weight: 200;
    font-style: normal;
}

@font-face {
    font-family: 'Butler';
    src: url('/fonts/Butler-Medium.woff2') format('woff2'),
        url('/fonts/Butler-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'Butler';
    src: url('/fonts/Butler-Light.woff2') format('woff2'),
        url('/fonts/Butler-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'Butler';
    src: url('/fonts/Butler-Black.woff2') format('woff2'),
        url('/fonts/Butler-Black.woff') format('woff');
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: 'Butler';
    src: url('/fonts/Butler-Bold.woff2') format('woff2'),
        url('/fonts/Butler-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'Butler';
    src: url('/fonts/Butler-ExtraBold.woff2') format('woff2'),
        url('/fonts/Butler-ExtraBold.woff') format('woff');
    font-weight: 800;
    font-style: normal;
}

@font-face {
    font-family: 'Butler';
    src: url('/fonts/Butler.woff2') format('woff2'),
        url('/fonts/Butler.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

* {
  box-sizing: border-box;
  outline: none;
}

ul {
  list-style: none;
  padding: 0;
}

a {
  color: #00A1ED;
  text-decoration: none;
  cursor: pointer;
}

a[disabled] {
  opacity: .5;
  pointer-events: none;
}

h1, h2, h3, h4, h5, h6, p {
  margin: 0;
}

img {
  max-width: 100%;
}

svg {
  pointer-events: none;
}

html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
  font-family: 'poppins', Helvetica, Arial, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-size-adjust: 100%;
  text-rendering: optimizeLegibility;
  color: #343434;
}

body {
  /* max-width: 1920px;
  margin: auto; */
  overflow-x: hidden;
  overflow-y: auto;
}

#app {
  max-width: 1920px;
  margin: auto;
}

#app,
main {
  display: block;
  min-height: 100%;
}

#app[edge] .not-edge,
#app:not([edge]) .edge {
  display: none !important;
}

#app .page-loader {
  position: fixed;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  opacity: 0;
  z-index: 9999;
  transition: opacity .16s ease-in;
  pointer-events: none;
  user-select: none;
  color:#00A1ED;
  text-transform: uppercase;
  letter-spacing: .2em;
  will-change: transform;
}

#app[page-loading] .page-loader {
  opacity: 1;
  transition: opacity .16s ease-out;
}

#app .page-loader img {
  display: block;
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
  will-change: transform;
}

[loader] {
  position: relative;
}

[loader]:after,
.loader {
  display: inline-block;
  vertical-align: middle;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin .72s linear infinite;
}

[loader]:before,
[loader]:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

[loader]:before {
  background: rgba(255,255,255,.8);
  z-index: 9;
}

[loader]:after {
  margin: auto;
  z-index: 10;
  color: #00A1ED;
  width: 32px;
  height: 32px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

#app[page="hackathon"] {
  max-width: none;
  background:#00A1ED;
}

#app[page="hackathon"] main {
  height: 100vh;
  background: #00A1ED;
}

input[type="number"] {
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

button {
  cursor: pointer;
  background: none;
  font: inherit;
  color: inherit;
  border: none;
}

.btn {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  line-height: 52px;
  color: #fff;
  background: #F77E0B;
  border-radius: 26px;
  font-size: 1rem;
  font-weight: 600;
  padding: 0 24px;
  min-width: 168px;
  text-transform: uppercase;
  flex-shrink: 0;
  margin: 0;
  overflow: hidden;
}

.btn.btn-s {
  height: 24px;
  line-height: 24px;
  padding: 0 16px;
  font-size: .79rem;
  font-weight: bold;
  min-width: 0;
}

.btn.btn-ic {
  justify-content: space-between;
}

.btn.btn-ic > * {
  flex-grow: 1;
  text-align: center;
}

.btn.btn-ic .btn-icon {
  margin-left: 8px;
  font-size: 1.43em;
  flex-grow: 0;
  flex-shrink: 0;
  transition: .16s transform .04s ease-out;
}

.btn.btn-ic .line1,
.btn.btn-ic .line2 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 0;
  overflow: hidden;
  margin: auto;
  display: none;
}

.btn.btn-ic span {
  transition: transform .16s ease-out;
}

@media screen and (min-width: 1025px) {
  .btn.btn-ic:hover:after {
    transition: transform .32s ease-in;
    transform: scale(1.1);
  }

  .btn.btn-ic:hover .btn-icon {
    transition: transform .16s ease-in;
    transform: translateX(calc(100% + 30px));
  }

  .btn.btn-ic:hover span {
    transition: .16s transform .04s ease-in;
    transform: translateX(12px);
  }
}

.btn.blue {
  background-color: #00A1ED;
}

.btn.green {
  background-color: #0D988C;
}

.btn.lime {
  background-color: #8ABB2A;
}

.btn.purple {
  background-color: #880F50;
}

.btn.clear {
  background-color: #BCBCCB;
}

.ic {
  display: inline-block;
  vertical-align: middle;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
}

.ic.ic-cookies {
  background-image: url(./assets/cast_ic_cookies.svg);
}

.ic.ic-download {
  background-image: url(./assets/cast_ic_download.svg);
}

.ic.ic-link {
  background-image: url(./assets/cast_ic_link.svg);
}

.ic.ic-menu {
  background-image: url(./assets/cast_ic_menu.svg);
}

.ic.ic-close {
  background-image: url(./assets/cast_ic_close.svg);
}

.ic.ic-close-b {
  background-image: url(./assets/cast_ic_close-b.svg);
}

.fieldgroup {
  display: flex;
  justify-content: space-between;
}

.field {
  width: 100%;
  margin-bottom: 16px;
}

.field.m {
  width: 48%;
}

.field label {
  display: block;
  font-weight: bold;
}

form .error {
  font-weight: bold;
  color: #ea2c3c;
  text-align: center;
  margin-bottom: 16px;
}

input,
select,
textarea {
  display: block;
  width: 100%;
  height: 36px;
  border: 1px solid #eee;
  border-radius: 0;
  padding: 0 16px;
  font: inherit;
  color: inherit;
  -webkit-appearance: none;
  background: none;
}

select {
  background: url(assets/cast_ic_arrow-down.svg) no-repeat 94% center/8px 8px;
  padding-right: 32px;
}

textarea {
  resize: none;
}

header {
  position: absolute;
  top: 68px;
  left: 0;
  right: 0;
  z-index: 99;
}

header > .wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

header .logo {
  display: block;
  width: 256px;
}

nav {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

nav a,
nav .btn {
  margin-left: 34px;
}

nav a {
  line-height: 1;
  padding: 4px 0;
  color: #fff;
  font-weight: 500;
  text-transform: uppercase;
}

nav[dark] a {
  color: #343434;
}

/* #app[page="home"] nav a.router-link-active:nth-child(1),
nav a:not(.btn).router-link-exact-active {
  border-bottom: 2px solid;
} */

nav .bar {
  position: absolute;
  top: 40px;
  left: 0;
  transform: translateX(34px);
  height: 2px;
  background: #fff;
  transition: all .16s ease-out;
}

nav[dark] .bar {
  background: #343434;
}

#app[page-loading] nav .bar {
  transition-delay: 10s;
}

.wrapper {
  position: relative;
  width: 1346px;
  max-width: calc(100% - 48px);
  margin: auto;
}

footer {
  position: relative;
  /* height: 850px; */
  margin-top: 68px;
  padding-bottom: 80px;
  /* background: url(./assets/cast_bg_footer.svg) no-repeat center bottom/1920px auto; */
}

footer > * {
  position: relative;
}

footer .footer-background {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 1920px;
  transform: translateX(-50%);
}

footer .footer-background svg,
footer .footer-background img {
  display: block;
  width: 100%;
  height: auto;
}

footer .socials {
  margin-top: 170px;
  letter-spacing: .58em;
  text-align: center;
  color: #fff;
}

footer .socials a {
  font-size: .83rem;
  margin: 0 10px;
  color: #fff;
}

footer .socials div {
  font-size: .72rem;
  text-transform: uppercase;
  margin-top: 2px;
}

footer .footer-logo {
  display: block;
  width: 362px;
  margin: auto;
}

footer .footer-copyright {
  text-align: center;
  margin-top: 46px;
  text-transform: uppercase;
  font-size: .78em;
  letter-spacing: .3em;
}

footer .footer-copyright a {
  display: inline-block;
  width: 72px;
  line-height: 1.1;
  border-bottom: 1px solid;
  color: inherit;
}

footer .footer-content {
  position: relative;
  display: flex;
  width: 1616px;
  max-width: 100%;
  margin: 16px auto 0;
  color: #fff;
  border-top: 1px solid rgba(255,255,255,.5);
  padding-top: 54px;
  padding-left: 8.2%;
  font-size: .78em;
}

footer .footer-content .footer-made-by {
  position: absolute;
  top: 16px;
  left: 0;
  right: 0;
  text-align: center;
}

footer .footer-content .footer-made-by a {
  font-weight: bold;
  color: #fff;
  text-decoration: underline;
}

footer .footer-content .flag {
  width: 120px;
  height: 80px;
  flex-shrink: 0;
  margin-right: 30px;
}

footer .footer-content .disclaimer {
  width: 787px;
  /* flex-shrink: 0; */
  margin-right: 152px;
}

footer .footer-content .links {
  width: 140px;
  flex-shrink: 0;
}

footer .footer-content .links a {
  display: block;
  color: inherit;
  text-decoration: underline;
}

.overlay {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,.8);
  z-index: 9999;
  pointer-events: none;
  opacity: 0;
  transition: opacity .16s ease-in;
}

#app[dialog] .overlay {
  pointer-events: all;
  opacity: 1;
}

.overlay .dialog {
  position: relative;
  width: 480px;
  background: #fff;
  padding: 16px 24px;
  border-radius: 4px;
}

.overlay .dialog .ic {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 16px;
  height: 16px;
}

.overlay .dialog h4 {
  font-size: 18px;
  color: #00A1ED;
  line-height: 1;
  margin-bottom: 8px;
}

.overlay .dialog.hackathon h4 {
  margin-top: 32px;
  font-size: 26px;
}

.overlay .dialog.hackathon h2 {
  font-size: 18px;
  margin-bottom: 8px;
}

.overlay .dialog.hackathon {
  font-size: 18px;
}

.overlay .dialog .dialog-footer {
  margin-top: 24px;
}

.cookie-bar {
  position: fixed;
  display: flex;
  align-items: center;
  left: 142px;
  bottom: 0;
  width: 256px;
  height: 56px;
  background: #fff;
  border-radius: 28px;
  text-transform: uppercase;
  font-size: .79em;
  padding: 0 14px;
  color: #707070;
  border: 1px solid #F7F7F7;
  box-shadow: 0 12px 25px rgba(0, 52, 77, .16);
  opacity: 0;
  pointer-events: none;
  transition: .16s opacity .16s ease-out, .16s transform .16s ease-in, bottom .16s ease-in;
  will-change: opacity, transform;
  z-index: 999;
}

.cookie-bar[opened] {
  transition: opacity .16s ease-in, transform .16s ease-out, .16s bottom .16s ease-out;
  transform: translateY(-92px);
  bottom: -24px;
  opacity: 1;
  pointer-events: all;
}

.cookie-bar a {
  font-weight: bold;
  color: inherit;
}

.cookie-bar .ic {
  width: 36px;
  height: 36px;
  margin: 0 8px;
}

.menu-btn,
footer .footer-contact-mobile,
footer .copyright-mobile {
  display: none;
}

@media screen and (max-width: 1400px) {
  nav a, nav .btn {
    margin-left: 24px;
  }
}

@media screen and (max-width: 1170px) {
  nav a, nav .btn {
    margin-left: 18px;
  }
}

@media screen and (min-width: 1024px) and (max-height: 840px) {
  #app[page="hackathon"] header .logo {
    width: auto;
    height: 58px;
  }
}

@media screen and (max-width: 1024px) {
  footer .footer-copyright,
  footer .footer-background,
  footer .footer-content .disclaimer br,
  .menu-btn.close-btn {
    display: none;
  }
  nav {
    position: fixed;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background: rgb(0,161,237);
    background: -moz-linear-gradient(324deg, rgba(0,161,237,1) 0%, rgba(13,152,140,1) 90%, rgba(13,152,140,1) 100%);
    background: -webkit-linear-gradient(324deg, rgba(0,161,237,1) 0%, rgba(13,152,140,1) 90%, rgba(13,152,140,1) 100%);
    background: linear-gradient(324deg, rgba(0,161,237,1) 0%, rgba(13,152,140,1) 90%, rgba(13,152,140,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00a1ed",endColorstr="#0d988c",GradientType=1);
    z-index: 9999;
    transform: translateY(-100%);
    transition: transform .16s ease-out;
    padding: 48px 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  nav a, nav .btn {
    margin: 12px 0;
    font-size: 16px;
  }
  nav .bar {
    display: none;
  }
  #app[menu-opened] {
    position: relative;
    overflow: hidden;
    height: 100%;
  }
  [menu-opened] nav {
    transform: none;
  }
  [menu-opened] .menu-btn.close-btn {
    display: block;
    position: fixed;
    top: 53px;
    right: 40px;
    z-index: 10000;
  }
  header {
    top: 0;
    padding: 30px 0 54px;
  }
  header:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    padding-top: 37.7%;
    background: url(assets/cast_m_header.svg) no-repeat center/contain;
    transition: transform .16s ease-out;
  }
  #app[page="hackathon"] main {
    height: auto;
  }
  #app[page="resources"] header:before {
    background-image: url(./assets/cast_m_header_resources.svg);
  }
  #app[page="partners"] header:before {
    background-image: url(./assets/cast_m_header_partners.svg);
  }
  #app[page="news"] header:before,
  #app[page="post"] header:before {
    background-image: url(./assets/cast_m_header_news.svg);
  }
  #app[page="events"] header:before,
  #app[page="event"] header:before {
    background-image: url(./assets/cast_m_header_events.svg);
  }
  header .logo {
    width: 190px;
  }
  .menu-btn {
    display: block;
    color: #fff;
    text-transform: uppercase;
    font-weight: 500;
    line-height: 1;
  }
  .menu-btn .ic {
    margin-right: 12px;
  }
  footer {
    background: url(assets/cast_m_footer.svg) no-repeat center bottom/contain;
    padding-bottom: 30%;
    margin-top: 56px;
  }
  #app[page="resources"] footer {
    background-image: url(./assets/cast_m_footer_resources.svg);
  }
  #app[page="partners"] footer {
    background-image: url(./assets/cast_m_footer_partners.svg);
  }
  #app[page="news"] footer,
  #app[page="post"] footer{
    background-image: url(./assets/cast_m_footer_news.svg);
  }
  #app[page="events"] footer,
  #app[page="event"] footer {
    background-image: url(./assets/cast_m_footer_events.svg);
  }
  footer .socials {
    text-align: center;
    margin-top: 46px;
    color: #00A1ED;
  }
  footer .socials a {
    display: inline-flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #00A1ED;
    margin: 0 8px;
    border: 1px solid rgba(0, 162, 237, 0.5);
    border-radius: 50%;
  }
  footer .socials a i {
    margin-left: 8px;
    font-size: 20px;
    text-align: center;
  }
  footer .socials div {
    margin-top: 8px;
  }
  footer .footer-logo {
    width: 256px;
  }
  footer .footer-contact-mobile {
    display: block;
    text-align: center;
    margin-top: 42px;
  }
  footer .footer-contact-mobile a {
    display: inline-block;
    width: 94px;
    font-weight: bold;
    text-transform: uppercase;
    color: #707070;
    letter-spacing: .58em;
    font-size: 11px;
    line-height: 1;
    border-bottom: 1px solid;
  }
  footer .footer-content {
    display: block;
    width: auto;
    color: #343434;
    padding: 14px 0 0;
    margin: 14px 24px 0;
    border-top: 1px solid rgba(0, 162, 237, 0.5);
    font-size: 11px;
  }
  footer .footer-content .flag {
    position: absolute;
    top: 42px;
    width: 107px;
    height: 71px;
  }
  footer .footer-content .footer-made-by {
    top: 12px;
  }
  footer .footer-content .footer-made-by a {
    color: #00A1ED;
  }
  footer .footer-content .disclaimer {
    width: auto;
    margin: 0;
    padding-top: 112px;
  }
  footer .footer-content .disclaimer span {
    position: absolute;
    top: 51px;
    left: 126px;
  }
  footer .footer-content .links {
    display: inline-block;
    margin: 30px 22px 0;
    vertical-align: top;
  }
  footer .footer-content .links:last-child {
    margin-right: 0;
  }
  footer .footer-content .links a {
    margin-top: 16px;
  }
  footer .copyright-mobile {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 18px;
    font-size: 11px;
    letter-spacing: .3em;
    text-align: center;
    color: #fff;
  }
  .cookie-bar {
    left: 0;
    right: 0;
    bottom: 24px;
    margin: auto;
  }
}

@media screen and (max-width: 436px) {
  header:before {
    top: 0;
    left: 50%;
    min-width: 414px;
    height: 156px;
    padding: 0;
    transform: translateX(-50%);
  }
}

@media screen and (max-height: 560px) {
  nav {
    justify-content: flex-start;
  }
}
</style>
